import { Card, Text, Group, rem, Skeleton } from '@mantine/core';

const InfoCard = ({
  title = 'Título',
  value = '—',
  subtitle = '',
  icon = null,
  bg = 'white',
  size = 'md',
  loading = false,
}) => {
  const titleSize = size === 'sm' ? 'sm' : size === 'lg' ? 'lg' : 'md';
  const valueSize = size === 'sm' ? 24 : size === 'lg' ? 40 : 32;

  return (
    <Card
      padding="md"
      radius="md"
      withBorder
      miw={rem(18)}
      mih={rem(14)}
      h={'100%'}
      bg={bg}
    >
      <Group justify="space-between" align="start" wrap='nowrap' mb={2}>
        <Text fw={500} size={titleSize}>{title}</Text>
        {icon && <div>{icon}</div>}
      </Group>
      {loading ? ( 
          <Skeleton height={16} width={'50%'} radius="xl" />
        ):(
          <Text size={rem(valueSize)} fw={600}>{value}</Text>
        )
      }
      {subtitle && 
        loading ? ( <Skeleton height={10} width={'30%'} mt={'xs'} radius="xl" />
        ):(
          <Text size="xs" c="dimmed" mt={'xs'}>{subtitle}</Text>
        )
      }
    </Card>
  );
};

export default InfoCard;
